import axios from 'axios'
import store from '../store'
import { Toast } from 'vant'
const baseURL = process.env.VUE_APP_BASE_API

const fetch = axios.create({
  baseURL: baseURL,
  timeout: 60000
})

// 全局loading处理
let loading
let count = 0
function startLoading() {
  loading = Toast.loading({duration: 0, forbidClick: true})
  count ++
  store.commit('setLoading', true)
}
function endLoading() {
  if (loading) {
    count --
    if (count <= 0) {
      loading.clear()
      count = 0
      store.commit('setLoading', false)
    }
  }
}

// 请求拦截
fetch.interceptors.request.use(req => {
  const { accessToken } = store.state
  if (accessToken) {
    req.headers['Authorization'] = `Bearer ${accessToken}`
  }
  // 动态控制loading
  if (!req.hideLoading) {
    startLoading()
  }
  return req
}, err => {
  endLoading()
  return Promise.reject(err)
})

// 响应拦截
fetch.interceptors.response.use(async res => {
  endLoading()
  
  // 监测token过期
  if (res.data.code == -1023) {
    // 发请求，刷新token
    // 注意：不能用fetch发，会死循环，因为fetch设置了请求拦截器，会注入老token
    // 用axios发请求
    const { data } = await axios({
      url: '/api/reservation/appUser/refreshToken',
      headers: {
        Authorization: `Bearer ${store.state.refreshToken}`
      }
    })
    if (data.code == 0) {
      store.commit('setToken', data.data)
      // 再发一次上次发送过的请求
      return fetch(res.config)
    } else {
      return Toast.fail('刷新token失败,请重新进入')
    }
  }

  return res.data
}, err => {
  endLoading()
  return Promise.reject(err)
})

export default fetch